import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Role } from '@/types/models';

interface User {
  id: string;
  name: string;
  email: string;
  role?: string;
  [key: string]: any; // Allow additional properties like roles array
}

interface ViewUsersDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  role: Role | null;
  users: User[];
  onUnassignUser: (userId: string) => void;
  onUnassignAllUsers: () => void;
  isProcessing?: boolean;
}

export const ViewUsersDialog: React.FC<ViewUsersDialogProps> = ({
  isOpen,
  onOpenChange,
  role,
  users,
 
  isProcessing = false
}) => {
  if (!role) return null;

  // Better filtering for assigned users - handle different role formats
  const assignedUsers = users.filter(u => {
    // Check traditional role field
    if (u.role && (u.role === role.name || u.role === role._id || u.role === role.id)) {
      return true;
    }
    
    // Check roles array (new structure)
    if (u.roles && Array.isArray(u.roles)) {
      return u.roles.includes(role.name) || u.roles.includes(role._id) || u.roles.includes(role.id);
    }
    
    return false;
  });
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Users with Role: {role.name}</DialogTitle>
          <DialogDescription>
            View users assigned to the "{role.name}" role.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          {isProcessing && (
            <div className="flex items-center justify-center p-4">
              <Loader2 className="h-6 w-6 animate-spin" />
              <span className="ml-2">Loading user assignments...</span>
            </div>
          )}
          <div className="space-y-2 max-h-[40vh] overflow-y-auto">
            {assignedUsers.map(u => (
              <div key={u.id} className="flex items-center justify-between p-3 border rounded-lg bg-gray-50">
                <div className="flex-1">
                  <p className="font-medium">{u.name}</p>
                  <p className="text-sm text-gray-500">{u.email}</p>
                  <p className="text-xs text-green-600 mt-1">✅ Assigned to {role.name}</p>
                </div>
              </div>
            ))}
            {assignedUsers.length === 0 && !isProcessing && (
              <p className="text-center text-gray-500 py-4">No users are assigned to this role.</p>
            )}
          </div>
          <DialogFooter className="mt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}; 